// src/configs.ts
var FUEL_NETWORK_URL = typeof process !== "undefined" ? process?.env?.FUEL_NETWORK_URL || "http://127.0.0.1:4000/graphql" : "http://127.0.0.1:4000/graphql";
export {
  FUEL_NETWORK_URL
};
//# sourceMappingURL=configs.mjs.map